export default __webpack_public_path__ + "static/media/icon_bandstyle_Tapered.cec582f1.png";